module.exports = __webpack_public_path__ + "static/inclusive-workplace-mobile.37cdcb85.webp";